import { render, staticRenderFns } from "./Theory.vue?vue&type=template&id=66156b0a&scoped=true"
import script from "./Theory.vue?vue&type=script&lang=js"
export * from "./Theory.vue?vue&type=script&lang=js"
import style0 from "./Theory.vue?vue&type=style&index=0&id=66156b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66156b0a",
  null
  
)

export default component.exports